module.exports = __webpack_public_path__ + "static/img/9.7dd32a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/9.png
// module id = 8noK
// module chunks = 0